import { Pipe, PipeTransform } from '@angular/core';

import { ProjectItem } from '../../services/project-detail.service';

@Pipe({
  name: 'tableDocCount',
  standalone: true,
})
export class TableDocCountPipe implements PipeTransform {
  transform(item: ProjectItem): number {
    switch (item.type) {
      case 'analysis':
        return item.analysis?.analysisCount || item.calculation?.documentCount;
      case 'collection':
        return item.collection.data.documentCount;
    }
    return item.displayData.docCount;
  }
}
